import React from 'react';
import {
	styled,
	ParentBoundComponent,
	Module,
} from 'ps-gui';

import Immutable from 'immutable';

import BankIdModel from './bankidmodel';
import { renderDateTimeCell } from './commoncellrenderers';
import {
	CellMainText,
	CellSubText
} from './portalresultsetmodule';
import CheckButton from '../components/checkbutton';
import { getPhrase } from '../data/phrases';

const Wrapper = styled.div`
`;

const QuickFilterHeader = styled.div`
	font-size: 14px;
	font-weight: 500;
	color: ${props => props.theme.disabledTextColor};
	margin-bottom: 8px;
`;

const QuickFilter = styled.div`
	margin-bottom: 24px;
	.checkButton {
		margin-right: 16px;
	}
`;

const EMPTY_MAP = Immutable.Map({});

export default class BankIdModule extends ParentBoundComponent {

	getModel() {
		return new BankIdModel(this.getData());
	}

	setModel(model) {
		this.setData(model.getData());
	}

	async componentDidMount() {
		if (!this.getData().get('initialized')) {
			this.setModel(await this.getModel().initialize());
		}
	}

	async setFixedFilter(name, value) {
		let model = this.getModel().setFixedFilter(name, value);
		model = await model.refreshSearch();
		this.setModel(model);
	}

	render() {
		const data = this.getData();
		const fixedFilter = data.get('fixedFilter') || EMPTY_MAP;
		return (
			<Wrapper>
				<QuickFilter>
					<CheckButton
						text={getPhrase('unmatched')}
						value={fixedFilter.get('unmatched')}
						onChange={value => this.setFixedFilter('unmatched', value)}
					/>
					<CheckButton
						text={getPhrase('matched')}
						value={fixedFilter.get('matched')}
						onChange={value => this.setFixedFilter('matched', value)}
					/>
					<CheckButton
						text={getPhrase('includingDeleted')}
						value={fixedFilter.get('deleted')}
						onChange={value => this.setFixedFilter('deleted', value)}
						marginLeft="64px"
					/>
				</QuickFilter>
				<Module
					appState={data.get('esad')}
					onDataChange={newData => {
						this.setData(data.setIn(['esad', 'data'], newData));
					}}
					customResultProps={customResultProps}
				/>
			</Wrapper>
		);
	}
}

const cellRendererMap = Object.freeze({
	'from_date': renderDateTimeCell,
	'to_date': renderDateTimeCell,
	'matched_user': (cell, row, colIndex) => {
		return (
			<>
				<CellMainText>{cell}</CellMainText>
				<CellSubText>{row.get('matched_user_display_name')}</CellSubText>
			</>
		);
	},
});

const customResultProps = {
	cellRendererMap,
	withNewEntityButton: false,
	defaultColumnWidths: {
		'bank_identity_id': '80px',
		'language': '114px',
		'phone_number': '140px',
		'from_date': '120px',
		'to_date': '120px'
	},
	columnFilters: {
		'name': {
			type: 'text',
		},
		'phone_number': {
			type: 'text',
		},
		'email': {
			type: 'text',
		},
		'from_date': {
			type: 'date'
		},
		'to_date': {
			type: 'date'
		},
		'birth_date': {
			type: 'date'
		},
	}
};

